<template>
  <div class="w-100">
    <div class="w-100" :class="{ 'border-b-semi-grey-dashed-2 mb-4 pb-4' : product_index+1 < getOutletTrxProducts.length || (product_index+1 == getOutletTrxProducts.length && product_i+1 < product_list.length) }" v-for="(product,product_i) in product_list">
      <div class="row no-gutters">
        <div class="col-1">
          <p class="text-14 text-center font-lato w-100 py-2 radius-6 border-form bg-grey-dark lh-1">{{ product.qty }}x</p>
        </div>
        <div class="col-7">
          <div class="pl-3">
            <p class="mb-0 body-2-1">{{ product.name }}</p>
            <p class="body-3-3-1 mb-1 w-100">Note : <b>{{ product.notes }}</b></p>
            <p class="mb-0 body-3-3-2 text-green cursor-pointer" v-if="!is_inquiry_done" @click="goToDetailProduct()">EDIT</p>
          </div>
        </div>
        <div class="col-4 text-right">
          <p class="mb-0 text-12 font-lato text-semi-light text-line-through" v-if="product.price_discount > 0">{{ $formatCurrency(product.base_price) }}</p>
          <p class="mb-0 text-14 font-lato">{{ $formatCurrency(product.price) }}</p>
          <p class="mb-0 body-3-3-2 text-danger cursor-pointer" v-if="!is_inquiry_done" @click="removeProduct(product)">REMOVE</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapMutations } from 'vuex'

  export default {
    inject: {
      cartContext: { default: null },
      posContext: { default: null }
    },
    props: ['data','product_index'],
    data() {
      return {
        
      }
    },
    computed:{
      ...mapGetters(['getOutletTrxProducts','getMerchant']),
      pos_code(){
        return this.$route.params.pos_code
      },
      is_variant(){
        return this.data.variants.length > 0 ? true : false
      },
      product_list(){
        const buildCartLine = ({ original, name, priceData, qty, notes }) => ({
          original,
          name,
          price: this.$getConciergeDisplayPrice(priceData)*qty,
          base_price: priceData.price_sell_base*qty,
          price_discount: priceData.promotion_amount*qty,
          qty,
          notes
        })

        if(this.is_variant){
          return this.data.variants.map(variant=>buildCartLine({
            original: variant,
            name: `${variant.variant_data.name} - ${this.data.product_data.name}`,
            priceData: variant.variant_data.price,
            qty: variant.qty,
            notes: variant.notes
          }))
        }

        return [buildCartLine({
          original: this.data,
          name: this.data.product_data.name,
          priceData: this.data.product_data.price,
          qty: this.data.qty,
          notes: this.data.notes
        })]
      },
      is_inquiry_done() {
        return this.cartContext && this.cartContext.tx_inquiry && this.cartContext.tx_inquiry.id ? true : false
      }
    },
    methods:{
      ...mapMutations(['removeTrxOutletProduct']),
      goToDetailProduct() {
        if (this.posContext && this.posContext.page_design_type === 'WIDE_VIEW') {
          this.posContext.product_detail_popup = {
            show: true,
            pos_id: this.data.product_data.product_pos[0].id,
            product_id: this.data.product_data.id
          }
          return
        }

        let route = {
          name: 'PosProductDetail',
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code,
            product_id: this.data.product_data.id
          },
          query: {
            pos_id: this.data.product_data.product_pos[0].id,
            from: 'PosCart'
          }
        }
        this.$router.push(route)
      },
      removeProduct(product){
        let params = {
          product: this.data.product_data,
          variant: this.is_variant ? product.original.variant_data : [],
          ref:  this.is_variant ? 'variant' : 'product',
          qty: product.qty,
          notes: product.notes
        }
        this.removeTrxOutletProduct(params)
      }
    }
  }
</script>
<style>
  .pos-order-qty {
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: grid;
    place-items: center;
    text-align: center;
    border-radius: 6px;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/ProductCart.vue